import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import { useEffect, useState } from "react";
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);
const ReactChartComponent = (props: any) => {
  const { dataColum, year } = props;
  var dataPost = dataColum?.map( (item: any) => item[year])
  
  const [data, setData] = useState({
    labels: ['Bài viết', 'Lượt truy cập'] as any,
    datasets: [] as any,
  });
  useEffect(() => {
    if (dataColum) {
      setData({
        labels: dataColum?.map(
          (item: any) => item.time
        ) as any,
        datasets: [
          {
            type: "line" as const,
            backgroundColor: "rgb(255, 99, 132)",
            borderColor: "rgb(255, 99, 132)",
            borderWidth: 2,
            fill: false,
            label: "Lượt truy cập",
            data: dataColum?.map(
              (item: any) => item['view']
            ) as any,
            yAxisID: "y",
            datalabels: {
              anchor: "end",
              align: "end", // Correct align value
              offset: 1,
            } as any,
          },
          {
            type: "bar" as const,
            backgroundColor: "#5B8FF9",
            label: "Bài viết",
            data: dataPost as any,
            borderColor: "white",
            borderWidth: 2,
            yAxisID: "y1",
          },
        ],
      });
    }
  }, [dataColum]);
  const options = {
    scales: {
      y: {
        position: "right" as const,
        beginAtZero: true,
      },
      y1: {
        position: "left" as const,
        beginAtZero: true,
      },
    },
    plugins: {
      legend: {
        position: "top" as const, // Valid value
      },
      datalabels: {
        color: "#000000",
        font: {
          size: 13,
          weight: "bold" as "bold",
        },
      },
    },
  };
  return (
    <Chart
      height={100}
      className="pt-4"
      plugins={[ChartDataLabels]}
      type="bar"
      data={data}
      options={options}
    />
  );
};

export default ReactChartComponent;